import { scope } from "@gr-exports/head/debug";
import { toggle } from "@gr-exports/head/toggle";
const grScope = scope("gr");
const deprScope = grScope.scope("deprecated");
function deprecated(moduleId, funcId, message) {
  const log = deprScope.scope(`${moduleId}.${funcId}`);
  const dataObject = new Error(`gr/${moduleId}/${funcId}: ${message}`);
  const caller = `${dataObject.stack}`.split("\n")[2];
  log.warn(`gr/${moduleId}/${funcId} is deprecated, ${message}.`);
  if (toggle.get(`gr_legacy_report_${moduleId.replace(/-/g, "_")}`, true)) {
    otto.apm.sendCustomError(`assets-legacy`, dataObject, { caller });
  }
}
export {
  deprecated,
  grScope
};
